export const PING_AN_AGREEMENT =
  "https://static3.yishouapp.com/obs/tools/agreement/2024/3/9/fdf44543f41ef1219c5d0d4c21b8c84c.html";
